
import React from 'react';
import { Link } from 'react-router-dom';
import releaseNotes from '../../data/release-notes.json';

const ReleaseNotes = () => {
  return (
    <div className="max-w-4xl mx-auto mt-10">
      <div className="bg-white p-8 sm:p-12 shadow-sm rounded-lg">
        {/* メインタイトル */}
        <h1 className="text-4xl font-extrabold text-gray-900 mb-10 pb-6 border-b border-gray-200">
          リリースノート
        </h1>
        
        <p className="text-gray-600 mb-12 text-lg">BillWaveの機能追加・改善・不具合修正などの最新情報をご案内します。</p>
        
        <div className="space-y-10">
          {releaseNotes.length > 0 ? (
            releaseNotes.map((note) => (
              <div key={note.id} className="group">
                <div className="flex flex-col gap-2">
                  <span className="text-sm font-mono text-gray-500">
                    {note.publishedAt.replace(/-/g, '/')}
                  </span>
                  <Link 
                    to={`/app/release-notes/${note.id}`} 
                    className="text-2xl font-bold text-gray-900 hover:text-blue-600 transition-colors leading-tight"
                  >
                    {note.title}
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500 py-16 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
              <p className="text-lg">現在リリースノートはありません。</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
